/* eslint-disable react/style-prop-object */
import React, { useEffect, useState } from 'react'
import { Button, Input, notification, Popconfirm, Table } from 'antd';
import UserDetailIcon from '../../../../assets/icons/UserDetailIcon';
import OrderService from '../../../../services/orderService';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import EyeIconComponent from '../../../../assets/icons/EyeIcon';
import DeleteIconComponent from '../../../../assets/icons/DeleteIcon';
const ManageOrders: React.FC = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [api, contextHolder] = notification.useNotification();

    const handleDelete = async (key: number) => {
        const obj = {
            id: key
        }
        const result = await OrderService.deleteOrderCMS(obj);
        if (result.response?.data.message === "success") {
            api.success({
                message: 'Xóa thành công đơn hàng!',
                showProgress: true,
                pauseOnHover: true,
            });
        }
        AdminGetAll();
    };


    const AdminGetAll = async () => {
        try {
            const result = await OrderService.AdminGetAll();
            if (result.data.message === 'success') {
                const filteredData = result.data.data.filter((item: any) => item.status !== 'Deleted');
                setData(filteredData);
            } else {
                notification.error({
                    message: 'Có lỗi xảy ra!',
                    description: result.data.message || 'Chi tiết lỗi không rõ.',
                });
            }
        } catch (error) {
            notification.error({
                message: 'Lỗi hệ thống máy chủ!',
            });
        }
    };

    const formatCurrency = (amount: number) => {
        return amount.toLocaleString('ko-KR', { style: 'currency', currency: 'KRW' });
    };

    const columns = [
        {
            title: 'Họ Tên',
            dataIndex: 'fullName',
            key: 'fullName',
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Địa chỉ',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            render: (status: string) => {
                if (status === 'Active') {
                    return <div className='text-success'>Đã xác nhận</div>;
                } else if (status === 'Order') {
                    return <div className='text-colorThird'>Chờ xác nhận</div>;
                } else {
                    return 'Trạng thái không xác định';
                }
            },
        },
        {
            title: 'Ghi chú',
            dataIndex: 'note',
            key: 'note',
        },
        {
            title: 'Tổng số tiền',
            dataIndex: 'totalAmount',
            key: 'totalAmount',
            render: (text: number) => formatCurrency(text),

        },
        {
            title: '',
            key: 'actions',
            render: (_: any, record: any) => (
                <span className='flex items-center justify-between'>
                    <Button type="link" onClick={() => handleClick(record.id)} >
                        <EyeIconComponent style={"w-6 h-6 fill-colorSecondary"} />
                    </Button>
                    <Popconfirm
                        title="Bạn có muốn xóa mục này không?"
                        onConfirm={() => handleDelete(record.id)}
                    >
                        <Button type="link" danger>
                            <DeleteIconComponent style='w-5 h-5 fill-colorThird' />
                        </Button>
                    </Popconfirm>
                </span>
            ),
        },
    ];
    useEffect(() => {
        AdminGetAll();
    }, []);

    const handleClick = (id: number) => {
        navigate(`/admin/don-hang/chi-tiet/${id}`);
    };

    const exportToExcel = () => {
        const filteredData = data.map(({ fullName, phone, email, address, status, note, totalAmount }) => ({
            fullName,
            phone,
            email,
            address,
            status,
            note,
            totalAmount
        }));

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

        XLSX.writeFile(workbook, 'orders.xlsx');
    };

    const handleExport = () => {
        exportToExcel();
    };
    const filteredData = data.filter((item: any) =>
        item.phone && item.phone.toString().includes(searchValue)
    );

    return (
        <div>
            {contextHolder}
            <div className='flex justify-end items-center mb-8'>
                <Input
                    placeholder="Tìm kiếm theo số điện thoại"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    style={{ marginRight: 16, width: 300 }}
                />
                <Button type="primary" onClick={handleExport}>
                    Xuất file XLSX
                </Button>
            </div>
            <Table columns={columns} dataSource={filteredData} />
        </div>
    );
};

export default ManageOrders
